import React from "react";
import PropTypes from "prop-types";
import Badge from "../wrappers/Badge";
import Button from "../wrappers/Button";

/**
 * Apresenta o gatilho mobile e anuncia uma contagem já calculada pelo consumidor.
 *
 * @param {object} pProps Propriedades do componente.
 * @param {string} pProps.label Rótulo do gatilho.
 * @param {number} pProps.appliedCount Quantidade de filtros aplicados.
 * @param {Function} pProps.onClick Callback de abertura.
 * @param {boolean} [pProps.disabled=false] Impede a abertura.
 * @returns {React.ReactElement}
 */
const SearchFiltersMobileTrigger = (pProps) => {
  const { label, appliedCount, onClick, disabled = false } = pProps;
  const xHasAppliedFilters = appliedCount > 0;
  const xAriaLabel = xHasAppliedFilters
    ? `${label}, ${appliedCount} filtros aplicados`
    : label;

  return (
    <Badge
      badgeContent={xHasAppliedFilters ? appliedCount : undefined}
      color="primary"
    >
      <Button
        aria-label={xAriaLabel}
        disabled={disabled}
        onClick={onClick}
        type="button"
        variant="outlined"
      >
        {label}
      </Button>
    </Badge>
  );
};

SearchFiltersMobileTrigger.propTypes = {
  label: PropTypes.string.isRequired,
  appliedCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SearchFiltersMobileTrigger;
